import { useEffect, useState } from "react";

import useDataBean from "../../../core/services/dataBean/useDataBean";

import { toast } from "react-toastify";
import { Singleton } from "../../../core/services/Singleton";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { BasicPage } from "../../theme/Component/BasicPage";
import { Modal } from "../../theme/Component/Modal";

import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AccountantConcept, _BusinessProcess, _FiscalResponsability, _FiscalResponsabilityType, _single } from "../../../core/services/dataBean/EntityCatalog";

import { _AdquisitionBeneficiary, _AdquisitionProject, _ArticleClassType, _MeasurementUnitCode, _ProjectBeneficiary, _ProjectSchedule } from "../../../core/services/dataBean/EntityCatalogVdos";

import useModal, { MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { InputDate } from "../../theme/Input/InputDate";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";
import { MyEditor } from "../../theme/Component/MyEditor";
import { FileInput } from "../../theme/Component/FileInput";
import { FileService } from "../../../core/services/FileService";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";



interface Props {
    IDProject: number;
}

export const ProjectSchedule = ({ IDProject }: Props) => {

    const { instance, lista, setLista, bean, setBean, update } = useDataBean(_ProjectSchedule);
    const fileService = new FileService();
    const single = Singleton.getInstance();
    const [documentos, setDocumentos] = useState<any>([]);

    const [plantilla, setplantilla] = useState<any>({ name: 'Ver Plantilla', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalConfirm = useModal("Agregar", MODAL_SM);
    const modalEditar = useModal("Agregar", MODAL_md);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });



    useEffect(() => {
        getLista()

    }, [IDProject])

    useEffect(() => {
        console.log(bean.JsonGuideMedia)
        try {
            let doc = JSON.parse(bean.JsonGuideMedia);
            doc.Filename = "Guia de la tarea";
            doc.Type = "pdf";
            doc.URLLink = fileService.getUrlFile(doc.MediaContext, doc.Media);
            setDocumentos([doc]);
        } catch (error) {

        }
    }, [bean])

    const getLista = () => {
        let filter = {
            IDProject:IDProject,
            State:1
        }   
        instance.getProjectScheduleRender(1,15,filter).then(
            (resp: any) => {
                setLista(resp.List);
            }
        );
    };



    const create = () => {
        setBean({
            IDEmployee: single.getAccountID(),
            State: 1,
            IDProject: IDProject
        });

        modalEditar.setModal({ ...modalEditar.modal, "view": true });
    }


    const editaItem = () => {

        update().then(
            (resp: any) => {
                getLista();
                modalEditar.setModal({ ...modalEditar.modal, "view": false });
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        bean.State = 2;
        editaItem();
        modalConfirm.close();
    }

    const head = [
        { title: 'ID', property: 'IDProjectSchedule', visible: false, },
        { title: 'Desde', property: 'FromDate', visible: false },
        { title: 'Hasta', property: 'UptoDate', visible: true },
        { title: 'Objectivo', property: 'Objective', visible: true },
        { title: 'Descripcion de la tarea', property: 'TaskDescription', visible: true, },
        // { title: 'Guia / Tarea', property: 'JsonGuideMedia', visible: true },
        { title: 'Area Responsable', property: 'IDLnFuctionalIDResposible', visible: true },
        { title: 'Responsable', property: 'IDAccountResponsible', visible: true },


    ]

    const [isValid, setIsValid] = useState<boolean>(false);
    const _busProcess = useDataBean(_BusinessProcess);
    const [obs, setObs] = useState<string>("")

    const handleModalSubmit = () => {
        if (!obs || obs.length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setIsValid(true);
            return;
        }

        setIsValid(false);

        const initProps = { ...bean };

        _busProcess.instance.requestBusinessProcess(
            bean.IDAccountResponsible,
            obs,
            "IDC",
            "IDProjectSchedule",
            bean.IDProjectSchedule,
            JSON.stringify(initProps),
            ""
        ).then((resp) => {
            toast.success(`Se ha Generado el Proceso ${resp.AlphaCode}`)
            setObs("");
        })
            .catch(err => console.log(err));
    };

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { modalEditar.setModal({ ...modalEditar.modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Ver Guía / Tarea', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setplantilla({ ...plantilla, "view": true }) } },
            { titulo: 'Iniciar Tramite', icono: 'ri-play-list-add-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Iniciar tramite de Cronograma" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <BasicPage titulo="Cronograma">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <AccountEditor label="Responsable" idAccount={bean.IDAccountResponsible} onChange={(e) => { setBean({ ...bean, "IDAccountResponsible": e.IDAccount }) }}></AccountEditor>
                                </div>
                                <div className="col-md-6">
                                    <InputDate label="Desde" value={bean.FromDate} name="FromDate" setDate={(e: any) => { setBean({ ...bean, 'FromDate': e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate label="Hasta" value={bean.UptoDate} name="UptoDate" setDate={(e: any) => { setBean({ ...bean, 'UptoDate': e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <label>Objectivo</label>
                                    <MyEditor val={bean.Objective} onChange={(e: any) => { setBean({ ...bean, 'Objective': e }) }}></MyEditor>
                                </div>
                                <div className="col-md-12">
                                    <label>Descripcion de la tarea</label>
                                    <MyEditor val={bean.TaskDescription} onChange={(e: any) => { setBean({ ...bean, 'TaskDescription': e }) }}></MyEditor>
                                </div>
                                <div className="col-md-6">
                                    {/* <FileInput
                                        Media={bean.Media}
                                        MediaContext={bean.MediaContext}
                                        directory='Project'
                                        label='Guia para la tarea'
                                        onCreate={({ MediaContext, Media }: any) => { setBean({ ...bean, "JsonGuideMedia": JSON.stringify({ MediaContext: MediaContext, Media: Media }) }); }}
                                    ></FileInput> */}
                                    <FileInput
                                        directory='Project'
                                        label='Guia para ejecutar la tarea'
                                        docAcept='application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf'
                                        onCreate={({ Media, MediaContext }: any) => {
                                            const url = fileService.getUrlFile(MediaContext, Media);
                                            let guia = JSON.stringify({ url, Media })
                                            setBean({ ...bean, "JsonGuideMedia": guia })
                                        }}
                                    ></FileInput>

                                </div>
                                <div className="col-md-6">
                                    <SelectFunctionalID label='Area Responsable' functionalIDLn={bean.IDLnFuctionalIDResposible} onChange={(e: any) => setBean({ ...bean, 'IDLnFuctionalIDResposible': e?.IDLn })} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>
                <div className="col-md-12">


                    <Modal modal={plantilla} updateModal={setplantilla} >
                        <>
                            <div className="col-md-12 mt-4">
                                {documentos.length > 0 &&
                                    <DocumentViewer list={documentos} />
                                }
                                {documentos.length === 0 &&
                                    <p>No hay documentos para visualizar</p>
                                }
                            </div>
                        </>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal onSubmitLabel="Solicitar" modal={modal} updateModal={setModal} eventModal={handleModalSubmit}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <textarea
                                    name="obs"
                                    rows={5}
                                    className={`form-control ${isValid ? "is-invalid" : ""}`}
                                    value={obs}
                                    onChange={(e) => setObs(e.target.value)}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}